module.exports = {
      navigation: [{"id":8,"name":"Sale","url":"trends/on-sale","highlighted":false,"flair":true},{"id":9,"name":"Selling Fast","url":"trends/selling-fast-this-week","highlighted":false,"flair":false},{"id":7,"name":"Kids","url":"shop/kids","highlighted":false,"flair":false}],
    }